
export default {
  props: {
    component: {
      type: Object,
      default() {
        return {
          title: 'Weit hinten, hinter den Wortbergen.',
          text: '<p>Fern der Länder Vokalien und Konsonantien leben die Blindtexte. Abgeschieden wohnen sie in Buchstabhausen an der Küste des Semantik, eines großen Sprachozeans. Ein kleines Bächlein namens Duden fließt durch ihren Ort und versorgt sie mit den nötigen <strong>Regelialien</strong>. Es ist ein paradiesmatisches Land, in dem einem gebratene Satzteile in den Mund fliegen. Nicht einmal von der allmächtigen Interpunktion werden die Blindtexte beherrscht – ein geradezu unorthographisches Leben. Eines Tages aber beschloß eine kleine Zeile Blindtext, ihr Name war Lorem Ipsum, hinaus zu gehen in die weite Grammatik. Der <em>große Oxmox</em> riet ihr davon ab, da es dort wimmele von bösen Kommata, wilden Fragezeichen und hinterhältigen Semikoli, doch das <a title="Beam mich hoch" href="https://novu.ch">Blindtextchen</a> ließ sich nicht beirren.</p>',
          image: {
            url: require('~/assets/img/placeholders/atramex-building.jpg'),
            alt: 'Atramex Gebäude von Aussen',
          },

          background_color: {
            value: 'white',
          },
        }
      },
    },
  },
}
